import React from 'react';
import styled from 'styled-components';
import { brandColours, fontSize, fontWeights } from '../../styles';

const StyledTag = styled.span`
  padding: 2px 12px;
  font-weight: ${fontWeights.bold};
  ${fontSize(12)};
  text-transform: uppercase;
  border: solid 1px ${brandColours.secondary};
  border-radius: 5px;
`;

export const Tag = ({ children, ...props }) => (
  <StyledTag {...props}>{children}</StyledTag>
);
